import React from 'react';
import { createRoot } from 'react-dom/client';
import WallBuilder from 'wb';
import { initSentry } from 'shared/sentry';
import { setupAnalytics } from 'arts/config/analytics';

document.addEventListener('DOMContentLoaded', () => {
  initSentry();
  setupAnalytics();
  const rootElement = document.getElementById('wall-builder-root');
  const root = createRoot(rootElement);
  root.render(<WallBuilder />);
});
